import { api } from "./clientInstance";

export const fetchPlayers = ()        => api("/players");
export const savePlayers  = (players) => api("/players", { method: "PUT", body: JSON.stringify(players) });
